import { ProductEditCommandModel } from "../product-base-model";

export class MerchandizeEditCommandModel extends ProductEditCommandModel {
}